import type { ApolloLink } from '@apollo/client';
import { createContext, useContext } from 'react';

export interface GraphQLCall {
  id: string;
  operation: ApolloLink.Operation;
  response: unknown;
  complexity: number;
  depth: number;
  subgraphs: string[];
}

type DebugContext = {
  recordGQLOperation: (call: GraphQLCall) => void;
};

export const DebugContext = createContext<DebugContext | null>(null);

export const useDebugContext = () => useContext(DebugContext)!;
